//Main screen
import * as React from "react";
import FilterBar from "../components/referral/ReferralFilterBar";
import PrescriberCards from "../components/referral/ReferralPrescriptionInfoCards";
import { Stack } from "@mui/system";
import { ThemeProvider, useTheme } from "@mui/material/styles";
import { UserContext } from "../contexts/userContext";
import { useRecoilState } from "recoil";
import { pageAtom, referralFilterAtom, referralInfoAtom } from "../atoms/atoms";
import { prescriptionGen } from "../utils/dictGen";
import { Box, CircularProgress } from "@mui/material";
import { ReferralService } from "../services/referralService";
import ErrorPage from "./ErrorPage";

export default function Referral() {
  const [filterOptions, setFilterOptions] = useRecoilState(referralFilterAtom);
  const [cardInfo, setCardInfo] = useRecoilState(referralInfoAtom);
  const [pages, setPages] = useRecoilState(pageAtom);
  const [loading, setLoading] = React.useState(false);
  const userCtx = React.useContext(UserContext);
  const PER_PAGE = 15;
  const theme = useTheme();
  const userPermissions = userCtx.user.user_secondary_roles.filter(
    (r) => r == 5
  );
  const { checkInAllNMRRecords, getAllNMR, getNumberOfNMRPages } =
    ReferralService();

  // async function getPages() {
  //   getNumberOfNMRPages(
  //     (data) => {
  //       const total = data.count;
  //       const pageCount = Math.ceil(parseInt(total) / PER_PAGE);
  //       setPages((prev) => ({
  //         ...prev,
  //         referralNumberOfPages: pageCount,
  //       }));
  //     },
  //     (err) => {
  //       console.log(err);
  //     }
  //   );
  // }

  async function getSubset() {
    setLoading(true);
    getAllNMR(
      PER_PAGE,
      pages.referralPage,
      null,
      (data) => {
        const allInfo = prescriptionGen(data.all);
        setCardInfo(allInfo);
        const total = data.count;
        const pageCount = Math.ceil(parseInt(total) / PER_PAGE);
        setLoading(false);
        setPages((prev) => ({
          ...prev,
          referralNumberOfPages: pageCount,
        }));
      },
      (err) => {
        console.log(err);
        setLoading(false);
      }
    );
  }

  const checkIn = () => {
    checkInAllNMRRecords(
      userCtx.user.user_id,
      (data) => {},
      (err) => {
        console.log(err);
      }
    );
  };

  React.useEffect(() => {
    checkIn();
    const filtered = filterOptions.filtered;
    if (filtered) return;
    getSubset();
  }, [setCardInfo, pages.referralPage]);

  if (userPermissions.length < 1) {
    return <ErrorPage />;
  }

  if (loading)
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <CircularProgress />
      </Box>
    );
  return (
    <ThemeProvider theme={theme}>
      <Stack direction={"column"} spacing={2} position={"relative"}>
        <FilterBar reset={getSubset} checkIn={checkIn} />
        <PrescriberCards getSubset={getSubset} />
      </Stack>
    </ThemeProvider>
  );
}
